import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Button, ButtonGroup, ModalComponent } from '@qure/containers'
import mixPanelEventsConstants from 'libs/mixPanelEventsConstants'
import onLogout from 'libs/onLogout'
import useMixPanelTracking from 'libs/MixpanelIntegration'

import './index.scss'

const withLogoutConfirm = WrappedComponent => {
  return props => {
    const [isLogoutLoading, setLogoutLoading] = useState(false)
    const [hasConfirmLogoutVisible, setConfirmLogout] = useState(false)
    const { t } = useTranslation()
    const history = useHistory()

    const mixPanel = useMixPanelTracking()

    const onLogoutConfirm = () => {
      setLogoutLoading(true)
      onLogout(history)
        .then(() => {
          mixPanel.track(mixPanelEventsConstants.$SESSION_END)
          setTimeout(() => {
            setLogoutLoading(false)
            setConfirmLogout(false)
          }, 600)
        })
        .catch(() => {
          mixPanel.track(mixPanelEventsConstants.$SESSION_END)
          setTimeout(() => {
            setLogoutLoading(false)
            setConfirmLogout(false)
          }, 600)
        })
    }

    return (
      <>
        <WrappedComponent {...props} setConfirmLogout={setConfirmLogout} />
        <ModalComponent
          modalTitle={t('Logout confirmation')}
          isOpen={hasConfirmLogoutVisible}
          onClose={() => setConfirmLogout(false)}
          className="logout-modal"
          modalActions={
            <ButtonGroup isCentered className="has-fullwidth">
              <Button
                onClick={onLogoutConfirm}
                isLoading={isLogoutLoading}
                isPrimary
              >
                {t('Logout')}
              </Button>
              <Button onClick={() => setConfirmLogout(false)} isPrimary={false}>
                {t('Cancel')}
              </Button>
            </ButtonGroup>
          }
        >
          <p className="popup-message">
            {t('Are you sure you want to logout from qTrack?')}
          </p>
        </ModalComponent>
      </>
    )
  }
}

export default withLogoutConfirm
